/** Clears scroll/modal locks left by client pages after route changes. */
export function resetBodyUiLocks(): void {
  if (typeof document === 'undefined') {
    return;
  }

  document.body.classList.remove(
    'mobile-search-overlay-open',
    'mobile-menu-open',
    'modal-open',
  );
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
}
